module.exports = __webpack_public_path__ + "static/media/1001300TL.99984095.jpg";